module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl2-75.8a1644a4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl2-75.png
// module id = 3557
// module chunks = 11